import { createReducer } from 'reduxsauce';
import { createSelector } from 'reselect';
import Immutable from 'seamless-immutable';
import { LoginTypes } from '../actions/LoginActions';
import {
  isValidEmail,
  isValidShortCode,
  isEmpty,
} from '../../services/Validation';
import { getSessionInfo } from '../../services/JwtStore';

/* ------------- Initial Login State ------------- */
export const INITIAL_STATE = Immutable({
  session: getSessionInfo() || null,
  error: '',
  fetching: false,
  authenticating: false,
  showEmailError: false,
  email: '',
  showPasswordError: false,
  password: '',
  lastActiveTime: null,
});

/* ------------- Reducers ------------- */
export const onRequest = (state) => state.merge({ authenticating: true });
export const onLoginSuccess = (state, { session }) =>
  state.merge({ authenticating: false, session, password: '' });
export const onLoginFailure = (state, { error }) =>
  state.merge({ authenticating: false, error });
export const onGetSessionSuccess = (state) =>
  state.merge({ authenticating: false });
export const onGetSessionFailure = (state, { error }) =>
  state.merge({ authenticating: false, error });
export const onLogout = () => INITIAL_STATE.merge({ session: null });
export const onEmailChange = (state, { email }) =>
  state.merge({ email, showEmailError: true });
export const onPasswordChange = (state, { password }) =>
  state.merge({ password, showPasswordError: true });
export const onSetLastActiveTime = (state, { lastActiveTime }) =>
  state.merge({ lastActiveTime });

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [LoginTypes.LOGIN_REQUEST]: onRequest,
  [LoginTypes.LOGIN_SUCCESS]: onLoginSuccess,
  [LoginTypes.LOGIN_FAILURE]: onLoginFailure,
  [LoginTypes.GET_SESSION_REQUEST]: onRequest,
  [LoginTypes.GET_SESSION_SUCCESS]: onGetSessionSuccess,
  [LoginTypes.GET_SESSION_FAILURE]: onGetSessionFailure,
  [LoginTypes.EMAIL_CHANGED]: onEmailChange,
  [LoginTypes.PASSWORD_CHANGED]: onPasswordChange,
  [LoginTypes.LOGOUT_SUCCESS]: onLogout,
  [LoginTypes.SET_LAST_ACTIVE_TIME]: onSetLastActiveTime,
});

/* ------------- Selectors ------------- */
export const isAuthenticating = (state) => state.login.authenticating;
export const getError = (state) => state.login.error;
export const getEmail = (state) => state.login.email;
export const getPassword = (state) => state.login.password;
export const shouldShowEmailError = (state) => state.login.showEmailError;
export const shouldShowPasswordError = (state) => state.login.showPasswordError;
export const getSession = (state) => state.login.session;
export const isFetching = (state) => state.login.fetching;
export const getPermissions = (state) =>
  state.login.session ? state.login.session.authorities : [];

// memoized
export const getEmailError = createSelector(getEmail, (email) =>
  isValidEmail(email) || isValidShortCode(email)
    ? ''
    : 'A valid email address is required'
);
export const getPasswordError = createSelector(getPassword, (password) =>
  isEmpty(password) ? 'Password is required' : ''
);
export const canLogin = createSelector(
  [getEmailError, getPasswordError],
  (emailError, passwordError) =>
    emailError.length === 0 && passwordError.length === 0
);
export const isAuthenticated = createSelector(
  getSession,
  (session) => session !== null
);
export const isLAO = createSelector(getSession, (session) =>
  session ? (session.authorities || []).includes('vis_lao_assign_r') : false
);
export const getCurrentUserAssignmentId = createSelector(
  getSession,
  (session) => (session ? session.currentAssignmentId : null)
);



// WEBPACK FOOTER //
// ./src/state/reducers/LoginReducer.js